import { convertCo2Score } from '@/data/http/utils/convert-co2-score';
import {
  CalculateVenueCo2,
  EMPTY_CALCULATE_VENUE_CO2,
} from '@/domain/impact-calculate-venue/entities/calculate-venue-co2.entity';

import { CalculateVenueCo2Dto } from './dto.type';

export class CalculateVenueCo2Mapper {
  static dtoToEntity(dto: CalculateVenueCo2Dto): CalculateVenueCo2 {
    return {
      global: {
        score: convertCo2Score(Number.parseFloat(dto.score.toString())),
        kgeCO2ByParticipant: NaN,
        scoreLetter: '',
      },
      structure: dto.structure
        ? {
            score: convertCo2Score(dto.structure.score),
            sectors: {
              site: {
                score: convertCo2Score(dto.structure.sectors.site.score),
                categories: {
                  scenography: convertScoreObject(
                    dto.structure.sectors.site.categories.scenography,
                  ),
                  material: convertScoreObject(
                    dto.structure.sectors.site.categories.material,
                  ),
                  building: convertScoreObject(
                    dto.structure.sectors.site.categories.building,
                  ),
                  energy: convertScoreObject(
                    dto.structure.sectors.site.categories.energy,
                  ),
                  water: convertScoreObject(
                    dto.structure.sectors.site.categories.water,
                  ),
                  waste: convertScoreObject(
                    dto.structure.sectors.site.categories.waste,
                  ),
                  equipment: convertScoreObject(
                    dto.structure.sectors.site.categories.equipment,
                  ),
                },
              },
              team: {
                score: convertCo2Score(dto.structure.sectors.team.score),
                categories: {
                  transport: convertScoreObject(
                    dto.structure.sectors.team.categories.transport,
                  ),
                  catering: convertScoreObject(
                    dto.structure.sectors.team.categories.catering,
                  ),
                },
              },
              public: {
                score: convertCo2Score(dto.structure.sectors.public.score),
                categories: {
                  catering: convertScoreObject(
                    dto.structure.sectors.public.categories.catering,
                  ),
                  digital: convertScoreObject(
                    dto.structure.sectors.public.categories.digital,
                  ),
                },
              },
            },
          }
        : EMPTY_CALCULATE_VENUE_CO2.structure,
      dates: {
        score: dto.events?.score
          ? convertCo2Score(dto.events.score)
          : EMPTY_CALCULATE_VENUE_CO2.dates.score,
        byMonth: {},
        byDate: {},
      },
    };
  }
}

function convertScoreObject(score: { score: number }) {
  return { score: convertCo2Score(score.score) };
}
